// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.da-fare {
  background: #ffffff;
  border: 2px solid #d1d5db;
  color: #374151;
}

.passata {
  background: #e8f5ec;
  border: 2px solid #2e7d4f;
  color: #1b4d32;
}

.attuale {
  background: #1d5fd6;
  border: 2px solid #0f3d91;
  color: #ffffff;
  box-shadow: 0 0 0 4px rgba(29, 95, 214, 0.25);
}

.prossima {
  background: #fff4e5;
  border: 2px dashed #c2410c;
  color: #7c2d12;
}

.alternativa, .fuori {
  background: #f3f4f6;
  border: 2px dotted #9ca3af;
  color: #4b5563;
}

.fase-card {
  box-sizing: border-box;
  width: 236px;
  border-radius: 12px;
  padding: 10px 12px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-areas: "num pos" "lav lav" "ris ris" "stato stato" "btn btn";
  align-items: center;
  gap: 6px 10px;
  font-size: 13px;
}
.fase-card small {
  font-size: 11px;
  opacity: 0.85;
}

.layout-colonna {
  width: 100%;
}

.layout-riga, .layout-footer {
  width: 100%;
  grid-template-columns: 56px minmax(0, 1.3fr) minmax(0, 1.3fr) minmax(0, 1fr) auto;
  grid-template-areas: "num lav ris pos btn" "num lav ris stato btn";
}
.layout-riga .f-pos, .layout-footer .f-pos {
  align-self: end;
}
.layout-riga .f-stato, .layout-footer .f-stato {
  align-self: start;
}
.layout-riga .f-btn, .layout-footer .f-btn {
  margin-top: 0;
}

.layout-footer {
  grid-template-columns: 56px minmax(0, 1.3fr) minmax(0, 1.3fr) minmax(0, 1fr) minmax(180px, auto);
}
.layout-footer .fase-bottoni {
  flex-direction: column;
  align-items: stretch;
}
.layout-footer .fase-storia {
  --border-color: currentColor;
  --border-width: 2px;
  font-weight: 700;
}

.f-num {
  grid-area: num;
  display: flex;
  flex-direction: column;
}

.f-pos {
  grid-area: pos;
  justify-self: start;
}

.f-lav, .f-ris {
  display: flex;
  flex-direction: column;
}
.f-lav b, .f-ris b {
  font-size: 14px;
}

.f-lav {
  grid-area: lav;
}

.f-ris {
  grid-area: ris;
}

.f-stato {
  grid-area: stato;
}

.f-btn {
  grid-area: btn;
}

.fase-numero {
  font-size: 20px;
  line-height: 1.1;
}

.fase-desc {
  font-size: 12px;
}

.fase-stato {
  font-size: 12px;
  font-weight: 500;
}

.fase-motivo, .fase-precedenti {
  display: block;
  font-weight: 700;
}

.fase-posizione {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #374151;
}

.passata .fase-posizione {
  background: #2e7d4f;
  color: #ffffff;
}

.attuale .fase-posizione {
  background: #ffffff;
  color: #1d5fd6;
}

.prossima .fase-posizione {
  background: #c2410c;
  color: #ffffff;
}

.alternativa .fase-posizione, .fuori .fase-posizione {
  background: #e5e7eb;
  color: #4b5563;
}

.fase-bottoni {
  display: flex;
  align-items: center;
  gap: 4px;
}
.fase-bottoni ion-button {
  min-height: 44px;
  margin: 0;
}
.fase-bottoni .fase-azione {
  flex: 1;
}

.fase-azione {
  --background: #ffffff;
  --color: #1d5fd6;
  --border-color: #1d5fd6;
  --border-style: solid;
  --border-width: 2px;
  font-weight: 700;
}

.attuale .fase-azione {
  --border-color: #ffffff;
}

.prossima .fase-azione {
  --background: #c2410c;
  --color: #ffffff;
  --border-color: #c2410c;
}

.passata .fase-azione {
  --color: #1b4d32;
  --border-color: #2e7d4f;
}

.fase-storia {
  --color: currentColor;
}`, "",{"version":3,"sources":["webpack://./src/app/_components/contenitori/contenitore-percorso/_percorso-posizioni.scss","webpack://./src/app/_components/contenitori/contenitore-percorso-fase/contenitore-percorso-fase.component.scss"],"names":[],"mappings":"AAEE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;ACDJ;;ADIE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;ACDJ;;ADIE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,6CAAA;ACDJ;;ADIE;EACE,mBAAA;EACA,0BAAA;EACA,cAAA;ACDJ;;ADIE;EACE,mBAAA;EACA,0BAAA;EACA,cAAA;ACDJ;;AAxBA;EACE,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,0CAAA;EACA,0EAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AA2BF;AAzBE;EACE,eAAA;EACA,aAAA;AA2BJ;;AAvBA;EACE,WAAA;AA0BF;;AAtBA;EACE,WAAA;EACA,iFAAA;EACA,kEAAA;AAyBF;AAvBE;EACE,eAAA;AAyBJ;AAtBE;EACE,iBAAA;AAwBJ;AArBE;EACE,aAAA;AAuBJ;;AAlBA;EACE,gGAAA;AAqBF;AAnBE;EACE,sBAAA;EACA,oBAAA;AAqBJ;AAlBE;EACE,4BAAA;EACA,mBAAA;EACA,gBAAA;AAoBJ;;AAhBA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;AAmBF;;AAhBA;EACE,cAAA;EACA,mBAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,sBAAA;AAmBF;AAjBE;EACE,eAAA;AAmBJ;;AAfA;EACE,cAAA;AAkBF;;AAfA;EACE,cAAA;AAkBF;;AAfA;EACE,gBAAA;AAkBF;;AAfA;EACE,cAAA;AAkBF;;AAfA;EACE,eAAA;EACA,gBAAA;AAkBF;;AAfA;EACE,eAAA;AAkBF;;AAfA;EACE,eAAA;EACA,gBAAA;AAkBF;;AAfA;EACE,cAAA;EACA,gBAAA;AAkBF;;AAdA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AAiBF;;AAdA;EACE,mBAAA;EACA,cAAA;AAiBF;;AAdA;EACE,mBAAA;EACA,cAAA;AAiBF;;AAdA;EACE,mBAAA;EACA,cAAA;AAiBF;;AAdA;EACE,mBAAA;EACA,cAAA;AAiBF;;AAdA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAiBF;AAfE;EACE,gBAAA;EACA,SAAA;AAiBJ;AAdE;EACE,OAAA;AAgBJ;;AAXA;EACE,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AAcF;;AAXA;EACE,uBAAA;AAcF;;AAXA;EACE,qBAAA;EACA,gBAAA;EACA,uBAAA;AAcF;;AAXA;EACE,gBAAA;EACA,uBAAA;AAcF;;AAXA;EACE,qBAAA;AAcF","sourcesContent":["// Feature 166: colori di posizione condivisi dalle viste del percorso (contrasto >= 4.5:1, mockup).\n@mixin posizioni {\n  .da-fare {\n    background: #ffffff;\n    border: 2px solid #d1d5db;\n    color: #374151;\n  }\n\n  .passata {\n    background: #e8f5ec;\n    border: 2px solid #2e7d4f;\n    color: #1b4d32;\n  }\n\n  .attuale {\n    background: #1d5fd6;\n    border: 2px solid #0f3d91;\n    color: #ffffff;\n    box-shadow: 0 0 0 4px rgba(29, 95, 214, .25);\n  }\n\n  .prossima {\n    background: #fff4e5;\n    border: 2px dashed #c2410c;\n    color: #7c2d12;\n  }\n\n  .alternativa, .fuori {\n    background: #f3f4f6;\n    border: 2px dotted #9ca3af;\n    color: #4b5563;\n  }\n}\n\n// Fuori dalle card: colori del tema, leggibili anche in modalità scura.\n@mixin freccia {\n  color: var(--ion-color-medium);\n  font-size: 20px;\n  font-weight: 700;\n}\n","@use '../contenitore-percorso/percorso-posizioni' as p;\n\n@include p.posizioni;\n\n// Verticale: numero e posizione in testa, poi lavorazione, risorsa, stato e bottoni.\n.fase-card {\n  box-sizing: border-box;\n  width: 236px;\n  border-radius: 12px;\n  padding: 10px 12px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  grid-template-areas: \"num pos\" \"lav lav\" \"ris ris\" \"stato stato\" \"btn btn\";\n  align-items: center;\n  gap: 6px 10px;\n  font-size: 13px;\n\n  small {\n    font-size: 11px;\n    opacity: .85;\n  }\n}\n\n.layout-colonna {\n  width: 100%;\n}\n\n// Timeline (mockup B): una riga a tutta larghezza, campi affiancati e bottone a destra.\n.layout-riga, .layout-footer {\n  width: 100%;\n  grid-template-columns: 56px minmax(0, 1.3fr) minmax(0, 1.3fr) minmax(0, 1fr) auto;\n  grid-template-areas: \"num lav ris pos btn\" \"num lav ris stato btn\";\n\n  .f-pos {\n    align-self: end;\n  }\n\n  .f-stato {\n    align-self: start;\n  }\n\n  .f-btn {\n    margin-top: 0;\n  }\n}\n\n// Footer della Mappa (mockup C): bottoni impilati, APRI/LANCIA sopra e «Storia ordine» sotto.\n.layout-footer {\n  grid-template-columns: 56px minmax(0, 1.3fr) minmax(0, 1.3fr) minmax(0, 1fr) minmax(180px, auto);\n\n  .fase-bottoni {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .fase-storia {\n    --border-color: currentColor;\n    --border-width: 2px;\n    font-weight: 700;\n  }\n}\n\n.f-num {\n  grid-area: num;\n  display: flex;\n  flex-direction: column;\n}\n\n.f-pos {\n  grid-area: pos;\n  justify-self: start;\n}\n\n.f-lav, .f-ris {\n  display: flex;\n  flex-direction: column;\n\n  b {\n    font-size: 14px;\n  }\n}\n\n.f-lav {\n  grid-area: lav;\n}\n\n.f-ris {\n  grid-area: ris;\n}\n\n.f-stato {\n  grid-area: stato;\n}\n\n.f-btn {\n  grid-area: btn;\n}\n\n.fase-numero {\n  font-size: 20px;\n  line-height: 1.1;\n}\n\n.fase-desc {\n  font-size: 12px;\n}\n\n.fase-stato {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.fase-motivo, .fase-precedenti {\n  display: block;\n  font-weight: 700;\n}\n\n// Etichetta di posizione a pastiglia, nel colore della card.\n.fase-posizione {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: .04em;\n  text-transform: uppercase;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.passata .fase-posizione {\n  background: #2e7d4f;\n  color: #ffffff;\n}\n\n.attuale .fase-posizione {\n  background: #ffffff;\n  color: #1d5fd6;\n}\n\n.prossima .fase-posizione {\n  background: #c2410c;\n  color: #ffffff;\n}\n\n.alternativa .fase-posizione, .fuori .fase-posizione {\n  background: #e5e7eb;\n  color: #4b5563;\n}\n\n.fase-bottoni {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  ion-button {\n    min-height: 44px;\n    margin: 0;\n  }\n\n  .fase-azione {\n    flex: 1;\n  }\n}\n\n// Bottoni nel colore della card: contorno blu sulle fasi da fare, bianco sull'attuale, arancio sulla prossima.\n.fase-azione {\n  --background: #ffffff;\n  --color: #1d5fd6;\n  --border-color: #1d5fd6;\n  --border-style: solid;\n  --border-width: 2px;\n  font-weight: 700;\n}\n\n.attuale .fase-azione {\n  --border-color: #ffffff;\n}\n\n.prossima .fase-azione {\n  --background: #c2410c;\n  --color: #ffffff;\n  --border-color: #c2410c;\n}\n\n.passata .fase-azione {\n  --color: #1b4d32;\n  --border-color: #2e7d4f;\n}\n\n.fase-storia {\n  --color: currentColor;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
